import { currentDivisionId } from 'common/src/stores/useFiltersStore';
import { getPreSettlementShipmentBoxes } from 'common/src/api/shipments';
import { createInFlightRequestCache } from 'common/src/utils/in-flight-request';
import { getWeekKey } from 'common/src/utils/functions';
import { ShipmentBox, User } from 'common/src/utils/types';

type GetShipmentsAllSourcesParams = {
  userProfile: User | null;
  session: { access_token: string } | null;
  selectedSeason?: string;
  selectedSpeciesId?: number;
  withReceptionDate?: boolean;
  withProcessDate?: boolean;
  demoShipments?: ShipmentBox[];
};

const normalizeShipmentBoxesFromDb = (boxes: ShipmentBox[]) =>
  boxes.map((box) => ({
    ...box,
    ship_trip_id: `${box.ship_name}-${box.ship_etd}-${box.ship_eta}`,
    week_etd: `${getWeekKey(box.ship_etd)}`,
    week_eta: `${getWeekKey(box.ship_eta)}`,
    unit_weight: box.box_weight,
    complete_format: `${box.box_format}-${box.box_weight}KG`,
  }));

const runShipmentBoxRequest = createInFlightRequestCache();

export const getShipmentsAllSources = async ({
  userProfile,
  selectedSeason,
  selectedSpeciesId,
  demoShipments = [],
}: GetShipmentsAllSourcesParams): Promise<ShipmentBox[]> => {
  const exporter = userProfile?.exporter;
  if (!exporter?.id || !selectedSeason || !selectedSpeciesId) {
    return [];
  }

  const hasDemo = exporter.hasDemo;

  if (hasDemo && demoShipments.length > 0) {
    return normalizeShipmentBoxesFromDb(demoShipments).map((box) => ({
      ...box,
      labeled_variety: box.labeled_variety ?? box.variety,
    }));
  }

  return runShipmentBoxRequest(
    JSON.stringify([
      userProfile?.id,
      exporter.id,
      selectedSeason,
      selectedSpeciesId,
      currentDivisionId(),
    ]),
    async () => {
      const data = await getPreSettlementShipmentBoxes(
        exporter.id,
        selectedSeason,
        selectedSpeciesId
      );
      if (data === null) throw new Error('No se pudieron cargar los despachos');
      return normalizeShipmentBoxesFromDb(data);
    }
  );
};
